<template>
  <svg
    class="icon"
    :width="size"
    :height="size"
    viewBox="0 0 16 16"
    fill="none"
    xmlns="http://www.w3.org/2000/svg"
  >
    <path
      fill-rule="evenodd"
      clip-rule="evenodd"
      d="M0 1C0 0.447715 0.447715 0 1 0H5C5.55228 0 6 0.447715 6 1C6 1.55228 5.55228 2 5 2H2V5C2 5.55228 1.55228 6 1 6C0.447715 6 0 5.55228 0 5V1Z"
      :fill="color"
    />
    <path
      fill-rule="evenodd"
      clip-rule="evenodd"
      d="M14 -4.37114e-08C14.5523 -1.95703e-08 15 0.447715 15 1L15 5C15 5.55228 14.5523 6 14 6C13.4477 6 13 5.55228 13 5L13 2L10 2C9.44772 2 9 1.55228 9 1C9 0.447715 9.44772 -2.42698e-07 10 -2.18557e-07L14 -4.37114e-08Z"
      :fill="color"
    />
    <path
      fill-rule="evenodd"
      clip-rule="evenodd"
      d="M15 14C15 14.5523 14.5523 15 14 15L10 15C9.44772 15 9 14.5523 9 14C9 13.4477 9.44772 13 10 13L13 13L13 10C13 9.44772 13.4477 9 14 9C14.5523 9 15 9.44772 15 10L15 14Z"
      :fill="color"
    />
    <path
      fill-rule="evenodd"
      clip-rule="evenodd"
      d="M1 15C0.447715 15 -1.95703e-08 14.5523 -4.37114e-08 14L-2.18557e-07 10C-2.42698e-07 9.44772 0.447715 9 1 9C1.55228 9 2 9.44772 2 10L2 13L5 13C5.55228 13 6 13.4477 6 14C6 14.5523 5.55228 15 5 15L1 15Z"
      :fill="color"
    />
  </svg>
</template>

<script>
export default {
  name: "IconFullscreen",

  props: {
    // цвет иконки
    color: {
      type: String,
      default() {
        return this.$vuetify.theme.textPrimary;
      }
    },
    // размер
    size: {
      type: String,
      default: "16"
    }
  }
};
</script>
